import {
  AccountCircle,
  MenuRounded,
  PowerSettingsNew,
} from "@mui/icons-material";
import { Button, IconButton, Stack } from "@mui/material";
import React from "react";
import { styled } from "styled-components";
import { useAuth } from "../../hooks/useAuth";
import NotificationBadge from "../notification/NotificationBadge";
import { Tooltip } from "antd";
import { DrawerComponent } from "../drawer/DrawerComponent";
import { LeftMenu } from "../menu/LeftMenu";

export const AppBar = () => {
  const { user, logout } = useAuth();

  return (
    <AppBarWrapper className="flexSpaceCenter whiteBg">
      <Stack direction="row" gap={3} alignItems="center">
        <MenuWrapper>
          <DrawerComponent
            className="leftmenu"
            width={201}
            bgColor="#001529"
            placement="left"
            padding={0}
            button={
              <Button
                variant="outlined"
                color="inherit"
                sx={{
                  width: 0,
                  height: 0,
                  minWidth: "35px",
                  minHeight: "35px",
                  color: "#b5b5b5",
                }}
              >
                <MenuRounded />
              </Button>
            }
          >
            <LeftMenu />
          </DrawerComponent>
        </MenuWrapper>

        <h3>Admin Dashboard</h3>
      </Stack>

      <Stack direction="row" spacing={1}>
        <AccountWrapper className="lightBg flexCenter gap10 font12 pointer animate">
          <AccountCircle />
          <div>
            <p className="bold">{user?.displayName || user?.email}</p>
            <p className="light font11">{user?.email}</p>
          </div>
        </AccountWrapper>

        <IconButton>
          <NotificationBadge />
        </IconButton>

        <Tooltip title="Logout">
          <IconButton onClick={logout}>
            <PowerSettingsNew />
          </IconButton>
        </Tooltip>
      </Stack>
    </AppBarWrapper>
  );
};

const AppBarWrapper = styled.div`
  width: 100%;
  padding: 1rem;
  height: 60px;
  border-bottom: 1px solid #e7e7e7;
`;

const AccountWrapper = styled.div`
  line-height: 1.4;
  border-radius: 10px;
  padding: 0 15px 0 10px;
  @media (max-width: 860px) {
    display: none;
  }
  &:hover {
    background-color: #dad8d8;
    scale: 0.98;
  }
`;

const MenuWrapper = styled.div`
  display: none;
  @media (max-width: 860px) {
    display: block;
  }
`;
